import React from 'react';
import type { BaseToastRendererProps } from '@lib/components/toast-system/toast-manager';
import clsx from 'clsx';

import Icon from '@/components/atoms/icon';

import type { ToastDefinition } from './toast-system-default.types';

import styles from './styles.scss';

export type ToastRendererProps = BaseToastRendererProps<ToastDefinition>;

const ToastRenderer = (props: ToastRendererProps) => {
  const {
    ContentComponent,
    content,
    id,
    onDismiss,
    showDismissButton,
    variant = 'primary',
  } = props;

  // review: consider moving this resolver to the `ToastManager` component
  const resolvedContent = ContentComponent ? <ContentComponent onDismiss={onDismiss} /> : content;

  return (
    <div data-id={id} role="alert" className={clsx(styles.toast, styles[variant])}>
      <div className={styles.toastContent}>{resolvedContent}</div>
      {showDismissButton ? (
        <button onClick={onDismiss} type="button" data-testid="toast-dismiss-button">
          <Icon name="clear" className={clsx(styles.dismissIcon, styles[variant])} />
        </button>
      ) : null}
    </div>
  );
};

export default ToastRenderer;
